import React, { useEffect, useRef, useState } from 'react';
import MemberLayout from '../../components/MemberLayout';
import { getMyMessages, sendMessage } from '../../services/api';

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [content, setContent] = useState('');
  const [sending, setSending] = useState(false);
  const bottomRef = useRef(null);

  const loadMessages = () => {
    getMyMessages().then((res) => setMessages(res.data)).catch(() => {});
  };

  useEffect(() => { loadMessages(); }, []);
  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    setSending(true);
    try {
      await sendMessage(content);
      setContent('');
      loadMessages();
    } finally {
      setSending(false);
    }
  };

  return (
    <MemberLayout title="Messages">
      <div className="card" style={{ maxWidth: 640, display: 'flex', flexDirection: 'column', height: 480 }}>
        <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
          {messages.length === 0 && <p>No messages yet. Send a message to the organisation below.</p>}
          {messages.map((m) => (
            <div
              key={m.id}
              style={{
                alignSelf: m.sender === 'MEMBER' ? 'flex-end' : 'flex-start',
                background: m.sender === 'MEMBER' ? 'var(--color-gold)' : '#f0efe9',
                color: m.sender === 'MEMBER' ? 'var(--color-black)' : 'inherit',
                padding: '10px 14px',
                borderRadius: 10,
                maxWidth: '75%',
              }}
            >
              {m.content}
            </div>
          ))}
          <div ref={bottomRef} />
        </div>
        <form onSubmit={handleSend} style={{ display: 'flex', gap: 10 }}>
          <input
            style={{ flex: 1, padding: 12, border: '1.5px solid #d9d5c8', borderRadius: 4 }}
            placeholder="Type a message..."
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
          <button className="btn btn-gold" disabled={sending}>Send</button>
        </form>
      </div>
    </MemberLayout>
  );
}
